export default __webpack_public_path__ + "static/media/sy.78c23a80.svg";